import { render, staticRenderFns } from "./AutoSnackbar.vue?vue&type=template&id=0c723dde"
import script from "./AutoSnackbar.vue?vue&type=script&lang=js"
export * from "./AutoSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports